module.exports = __webpack_public_path__ + "img/97.2.ae204aa0.png";